import { ElementTypeDto } from 'api/elements/Models/ElementTypeDto';
import { SupplierDto } from 'api/suppliers/models/SupplierDto';
import { TaxDto } from 'api/taxes/models/TaxDto';
import { UnitDto } from 'api/units/models/UnitDto';
import { useFormContext, useWatch } from 'react-hook-form';
import { LinesDataProvider } from 'screens/business/budgets/budget/lines/LinesDataProvider';
import BudgetLinesTable from 'screens/business/budgets/budget/lines/table/BudgetLinesTable';
import { BudgetsCacheData } from 'screens/business/budgets/budget/utils/BudgetsCache';

interface Props {
    type: 'create' | 'details' | 'edit' | 'version' | undefined;
    units: UnitDto[];
    taxes: TaxDto[];
    suppliers: SupplierDto[];
    elementTypes: ElementTypeDto[];
    budgetData: BudgetsCacheData;
}

function BudgetComponentLines({ type, units, taxes, suppliers, elementTypes, budgetData }: Props): JSX.Element | null {
    const isDetails = type === 'details' || type === 'version';
    const { control } = useFormContext();
    const description = useWatch({ control, name: 'description' }) as string | undefined;

    return (
        <LinesDataProvider.Provider value={{ taxes, units, suppliers, elementTypes, hiddenColumns: budgetData.hiddenColumns, columnsOrder: budgetData.columnsOrder ?? [], isComponentEditor: true, rootSectionDesignationOverride: description ?? '' }}>
            <BudgetLinesTable
                disabled={isDetails}
            />
        </LinesDataProvider.Provider>
    );
}

export default BudgetComponentLines;
